class WriteEmitter {
    writeLogs = new Set();
    ignoreCounter = 0;
    listeners = new Set();
    action(fn) {
        const runInAction = this.runInAction.bind(this);
        return function (...args) {
            return runInAction(() => fn.apply(this, args))[0];
        };
    }
    runInAction(f) {
        const writeLog = new Map();
        this.writeLogs.add(writeLog);
        try {
            return [f(), writeLog];
        }
        finally {
            this.writeLogs.delete(writeLog);
            if (this.writeLogs.size === 0 && writeLog.size > 0) {
                this.listeners.forEach((listener) => listener(writeLog));
            }
        }
    }
    ignore(f) {
        this.ignoreCounter++;
        try {
            return f();
        }
        finally {
            this.ignoreCounter--;
        }
    }
    on(listener) {
        this.listeners.add(listener);
    }
    off(listener) {
        this.listeners.delete(listener);
    }
    emit(me) {
        if (this.ignoreCounter > 0) {
            return;
        }
        if (this.writeLogs.size === 0) {
            this.listeners.forEach((listener) => listener(new Map([[me.target, new Map([[me.prop, me.value]])]])));
        }
        else {
            for (const writeLog of this.writeLogs.values()) {
                if (!writeLog.has(me.target)) {
                    writeLog.set(me.target, new Map());
                }
                const writeMap = writeLog.get(me.target);
                writeMap.set(me.prop, me.value + (writeMap.get(me.prop) ?? 0));
            }
        }
    }
}
const writeEmitter = new WriteEmitter();
export const action = writeEmitter.action.bind(writeEmitter);
export const runInAction = writeEmitter.runInAction.bind(writeEmitter);
export const ignore = writeEmitter.ignore.bind(writeEmitter);
export default writeEmitter;
